<template>
  <Container>
    <h1>Joueurs</h1>
    <div class="player" v-for="player in players" v-bind:key="player.id">
      <a v-bind:class="{'available-player': player.available, 'unavailable-player': !player.available}" v-on:click="changePlayerState(player.id)">{{player.name}}</a>
      <span v-if="player.priority" class="priority-player">Prioritaire</span>
    </div>
  </Container>
</template>

<script>
// @ is an alias to /src
import Notification from "@/components/Notification.vue";
import Match from "@/components/Match.vue";
import Container from "@/components/Container.vue";
import axios from "axios";

export default {
  name: "players",
  components: {
    Container
  },
  computed: {
    players(){
      return this.$store.state.players;
    }
  },
  methods: {
    changePlayerState: function(id){
      let player = this.players.find(p => p.id === id)
      if (player.available){
        axios.get("/players/disable/" + id).then(response => {
          this.$snack.success('Joueur rendu indisponible')
        });
      } else{
        axios.get("/players/enable/" + id).then(response => {
          this.$snack.success('Joueur rendu disponible')
        });
      }
    }
  }
};
</script>
<style scoped>
  .available-player{
    background-color: chartreuse;
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 10px;
    border-radius: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .unavailable-player{
    background-color: lightcoral;
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 10px;
    border-radius: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .priority-player{
    background-color: grey;
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: 10px;
    margin-top: 10px;
    border-radius: 10px;
    display: inline-block;
  }
</style>
